// extracted by mini-css-extract-plugin
module.exports = {"animSlideTop":"NotificationManager__animSlideTop__2o1Hq","animSlideBottom":"NotificationManager__animSlideBottom__3NbCj"};